// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drive-preview[data-v-5d2e8ee2]{height:72vh;overflow:auto;text-align:center}.drive-preview img[data-v-5d2e8ee2]{max-width:100%;max-height:100%}.drive-preview video[data-v-5d2e8ee2]{max-width:100%;height:100%}.drive-preview iframe[data-v-5d2e8ee2]{width:100%;height:100%;border:0}.text-preview[data-v-5d2e8ee2]{white-space:pre-wrap;text-align:left;overflow-wrap:anywhere;font:14px/1.7 monospace;padding:20px}", ""]);
// Exports
module.exports = exports;
